export { default as PromoText } from "./PromoText";
